<template>
    <div>
        <h4 class="pb-1 bb-2">{{ title }}</h4>

        <p class="fs-3 mt-3 gray-60">{{ subtitle }}</p>

        <el-table
            v-if="banks.length > 0"
            :data="banks"
            :show-header="false"
            border
            style="width: 100%"
        >
            <el-table-column>
                <template slot-scope="scope">
                    <p class="info-label">{{ $l10n.__('Banque') }}</p>
                    <p class="info-value">{{ scope.row.bankName }}</p>
                </template>
            </el-table-column>
            <el-table-column>
                <template slot-scope="scope">
                    <p class="info-label">{{ $l10n.__('Nom du compte') }}</p>
                    <p v-if="scope.row.accountName" class="info-value">
                        {{ scope.row.accountName }}
                    </p>
                    <p v-else class="info-value orange">{{ $l10n.__('Non renseigné') }}</p>
                </template>
            </el-table-column>
            <el-table-column>
                <template slot-scope="scope">
                    <bank-status :status="scope.row.status" v-if="scope.row.status != null" />
                </template>
            </el-table-column>
            <el-table-column>
                <template slot-scope="scope">
                    <div class="aright">
                        <CompassButton
                            :label="$t.__('preferences.BankTable.view_more')"
                            type="secondary"
                            @click="$emit('open', scope.row.id)"
                        />
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import BankStatus from './BankStatus.vue';

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        banks: {
            type: Array,
            required: true,
        },
    },
    components: {
        BankStatus,
    },
};
</script>

<style>
.sub-title {
    border-top: solid 2px lightgray;
    color: gray;
}

/* RESET TO DEFAULT STYLE */
.el-table td,
.el-table th {
    border-right: none;
    border-bottom: none;
}
</style>
